<template>
  <div id="slide" v-bind:class="{'guide-off': !guideOn}">
    <div id="training-slides" ref="slides"></div>
    <div id="slide-control" v-show="numberOfPages > 1">
      <ul class="commands">
        <li v-show="config.toc.length > 0"><label class="subject-opener" for="subjects-drawer-checkbox"></label></li>
        <li><input type="checkbox" id="guide-switch" v-model="guideOn"><label class="guide-switcher" for="guide-switch"></label></li>
      </ul>
      <div class="pager">
        <a href="javascript:void(0)" v-on:click="prevPage" v-bind:disabled="isFirstPage" v-bind:class="{prev: true, disabled: isFirstPage}"></a>
        <div class="page">
          <span class="current">{{ currentPage }}</span>
          /
          <span class="total">{{ numberOfPages }}</span>
        </div>
        <a href="javascript:void(0)" v-on:click="nextPage" v-bind:disabled="isLastPage" v-bind:class="{next: true, disabled: isLastPage}"></a>
      </div>
    </div>

    <div class="drawer left">
      <input type="checkbox" class="drawer-checkbox" id="subjects-drawer-checkbox" v-model="tocOpened">
      <div class="drawer-content">
        <div class="nav">
          <label for="subjects-drawer-checkbox" class="drawer-closer"></label>
        </div>
        <div class="body">
          <div class="drawer-title subject">目次</div>
          <ul class="subjects">
            <li v-for="toc1 in config.toc" v-bind:key="toc1.page">
              <a href="javascript:void(0)" v-on:click="setPage(toc1.page)">{{ toc1.title }}</a>
              <ul v-if="toc1.children && toc1.children.length > 0">
                <li v-for="toc2 in toc1.children" v-bind:key="toc2.page">
                  <a href="javascript:void(0)" v-on:click="setPage(toc2.page)">{{ toc2.title }}</a>
                  <ul v-if="toc2.children && toc2.children.length > 0">
                    <li v-for="toc3 in toc2.children" v-bind:key="toc3.page">
                      <a href="javascript:void(0)" v-on:click="setPage(toc3.page)">{{ toc3.title }}</a>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="modal guide" id="guide-modal">
      <a href="javascript:void(0)" class="modal-closer" aria-label="Modal close"></a>
      <div class="contents">
        <div class="modal-body">
          <p>

          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TrainingViewer from './training-viewer'

  export default {
    name: 'TrainingViewerSp',
    extends: TrainingViewer,
    data () {
      return {
        // SP かどうか
        isSP: true,
      }
    },
    mounted () {
      // 埋め込まれるガイドの数が多いので、jQuery で設定する
      $(document)
        .on('click', '.sp-guide-opener', (e) => {
          const content = $(e.target).data('content')
          if (!$('#slide').hasClass('guide-off')) {
            $('#guide-modal > .contents > .modal-body').html(content)
            $('#guide-modal').addClass('active')
          }
        })
    },
  }
</script>

